import { render, staticRenderFns } from "./networkError.vue?vue&type=template&id=6f80457e&"
import script from "./networkError.vue?vue&type=script&lang=js&"
export * from "./networkError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports